import './PsychiatristBrief.less'
import useHistory from '@/hooks/useHistory'

const PsychiatristBrief = () => {
  const history = useHistory()

  const toPage = (val) => {
    if (val === 'form') {
      history.push('/PsychiatristForm', 'route')
    }else {
      history.push('/PsychiatristHistory', 'route')
    }
  }

  return (
    <div className='pg-psychiatrist-brief'>
      <img className='header' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/psychiatrist/brief-header.png' />
      <div className='btn-tabs'>
        <div className='btn' onClick={() => toPage('form')}>
          <img className='icon' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/psychiatrist/icon-01.png' />
          <span>立即咨询</span>
        </div>
        <div className='btn' onClick={() => toPage('record')}>
          <img className='icon' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/psychiatrist/icon-02.png' />
          <span>咨询记录</span>
        </div>
      </div>
      <div className='content'>
        <div className='title'>心理咨询服务简介: </div>
        <p>东区街道总工会设立职工心理咨询服务，立足于心理健康服务体系的工作格局，为职工提供专业的心理健康服务。依据工会的服务范围、服务对象，以做实心理健康服务为基点，为职工提供普惠服务，搭建心理健康服务窗口，及时为职工提供最贴切的心理服务，帮助职工做好良好的心理健康建设。</p>
      </div>
      <div className='content'>
        <div className='title'>服务对象: </div>
        <p>
          东区街道企事业单位在职职工，符合下列条件之一的，可申请预约咨询:<br />
          (1)中山市东区街道已建立工会的企业职工;<br />
          (2)中山市东区街道已建立工会的企业职工直系亲属，直系亲属指职工配偶、职工子女和职工双方父母;<br />
          (3)经心理咨询师了解及评估属于心理咨询范围内的职工，若超出心理咨询范围，如神经症、妄想等精神障碍类问题将及时进行转介。
        </p>
      </div>
    </div>
  )
}

export default PsychiatristBrief